import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { FundRoi } from "./types";

// GET /api/admin/mdf/funds/:id/roi → FundRoi
//
// Sub-bucket 15 — fund-detail ROI tab. Server-side aggregation joins
// mdf_requests (status ∈ {approved, spent}) with hubspot_deals (closed-won
// stage) and computes total_committed / total_spent / revenue + per-campaign
// breakdown. Distinct query key (`mdf.fundRoi(id)`) because an allocation
// edit shouldn't invalidate the ROI cache — ROI is purely request- and
// deal-attribution-driven.
export function useFundRoi(id: string) {
  return useQuery<FundRoi, ApiClientError>({
    queryKey: queryKeys.mdf.fundRoi(id),
    queryFn: () => apiFetch<FundRoi>(`/admin/mdf/funds/${id}/roi`),
    enabled: !!id,
  });
}
